import { Controller } from "react-hook-form";
import classNames from "classnames";

import { useMobileDevice } from "src/utils/hooks/viewport";

import { CDate, CSelect, CTextarea } from "_components/controls";

import { getAll as getAllMaterialGroup } from "../../../queries-fn/material-group.query";
import { getAll as getAllWarehouse } from "../../../queries-fn/warehouse.query";

export const Info = ({ control, setValue, handleSelectMaterialGroup }) => {
  //#region Data
  const { data: materialGroups } = getAllMaterialGroup({}, false);

  const { data: warehouses } = getAllWarehouse({}, false);

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onSelectWarehouse = ({ data, value }) => {
    setValue("store_code", data.store_code);
    setValue("ware_code", data.code);
  };
  //#endregion

  //#region Render
  return (
    <div
      className={classNames(
        "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4",
        isMobile ? "mt-0" : "mt-3",
      )}
    >
      <Controller
        name="checked"
        control={control}
        render={({ field }) => (
          <CDate maxDate={Date.now()} label="Ngày kiểm" required {...field} />
        )}
      />
      <Controller
        name="ware_code"
        control={control}
        render={({ field }) => (
          <CSelect
            options={warehouses}
            label="Kho kiểm"
            required
            {...field}
            onChange={onSelectWarehouse}
          />
        )}
      />
      <Controller
        name="group_code"
        control={control}
        render={({ field: { onChange, ..._field } }) => {
          return (
            <CSelect
              label="Nhóm Nguyên Vật Liệu"
              options={materialGroups}
              {..._field}
              required
              select="value"
              onChange={handleSelectMaterialGroup(onChange)}
            />
          );
        }}
      />
      <Controller
        name="note"
        control={control}
        render={({ field }) => (
          <CTextarea label="Ghi chú" placeholder="Nhập ghi chú" {...field} />
        )}
      />
    </div>
  );
  //#endregion
};
